export default __webpack_public_path__ + "static/winter41-fcd8c5dcbee2feda2112352b58028d79.webp";